"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _winCourseDeYu = _interopRequireDefault(require("@/components/winCourseDeYu.vue"));
var _index = require("@/api/virtualSimulationClass/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SptCoordinatorList',
  components: {
    winCourseDeYu: _winCourseDeYu.default
  },
  data: function data() {
    return {
      CoordinatorList: [],
      page: {
        pageNumber: 1,
        pageSize: 20
      },
      totalNumber: 0,
      loading: false
    };
  },
  created: function created() {
    this.getCourseList4();
  },
  methods: {
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getCourseList4();
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getCourseList4();
    },
    getCourseList4: function getCourseList4() {
      var _this = this;
      this.loading = true;
      (0, _index.getReceptionList)({
        courseName: this.courseName,
        courseSource: "",
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        projectLevel: "",
        provinceId: this.$store.getters.provinceId,
        courseType: '4',
        schoolId: '',
        majorName: this.majorName,
        isSpecial: true,
        showStatus: 1
      }).then(function (res) {
        _this.CoordinatorList = res.rows;
        _this.totalNumber = res.total;
        _this.loading = false;
      });
    }
  }
};